var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{attrs:{"data-qa":"ktv-sms-verification-status-alert-message"}},[_vm._v(_vm._s(_vm.i18nStatusMessage))])
}
var staticRenderFns = []

export { render, staticRenderFns }